import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b9f22372&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9f22372')) {
      api.createRecord('b9f22372', component.options)
    } else {
      api.reload('b9f22372', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b9f22372&", function () {
      api.rerender('b9f22372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/settings/index.vue"
export default component.exports